export function getWhatsAppLink(pathname) {
  const number = "5527995785444";

  let intro = "Olá! Quero uma proposta para meu evento.";
  let context = "";

  if (pathname === "/cenografia") {
    context = "Tenho interesse em um projeto de CENOGRAFIA.";
  } else if (pathname === "/iluminacao") {
    context = "Tenho interesse em um projeto de ILUMINAÇÃO CÊNICA.";
  } else if (pathname === "/portfolio") {
    context = "Vi o portfólio e quero algo nesse nível.";
  } else if (pathname === "/contato") {
    context = "Quero conversar sobre um projeto.";
  }

  const text = encodeURIComponent(
    `${intro}\n\n${context}\n\n` +
      "• Data do evento:\n" +
      "• Cidade/Local:\n" +
      "• Tipo de evento:\n" +
      "• Referências (se tiver):\n"
  );

  return `https://wa.me/${number}?text=${text}`;
}
